import {
    Dumbbell,
    Flame,
    Footprints,
    Gauge,
    Heart,
    Info,
    LayoutGrid,
    MapPin,
    Mountain,
    PersonStanding,
    Ruler,
    Timer
} from 'lucide-react';

export const getMetricIcon = (key: string) => {
    const normalized = key.toLowerCase();

    if (normalized.includes('distance')) return Ruler;
    if (normalized.includes('duration') || normalized.includes('time'))
        return Timer;
    if (normalized.includes('heart')) return Heart;
    if (normalized.includes('pace') || normalized.includes('speed'))
        return Gauge;
    if (normalized.includes('calorie') || normalized.includes('burned'))
        return Flame;
    if (normalized.includes('elevation')) return Mountain;
    if (normalized.includes('step')) return Footprints;
    if (normalized.includes('workout') || normalized.includes('activitytype'))
        return PersonStanding;
    if (normalized.includes('facility') || normalized.includes('visit'))
        return Dumbbell;
    if (
        normalized.includes('location') ||
        normalized.includes('latitude') ||
        normalized.includes('longitude')
    ) {
        return MapPin;
    }
    if (normalized.includes('source') || normalized.includes('device'))
        return LayoutGrid;

    return Info;
};

export const getMetricIconTone = (key: string): string => {
    const normalized = key.toLowerCase();

    if (normalized.includes('distance')) return 'text-warning';
    if (normalized.includes('duration') || normalized.includes('time'))
        return 'text-info';
    if (normalized.includes('heart')) return 'text-destructive';
    if (normalized.includes('pace') || normalized.includes('speed'))
        return 'text-warning';
    if (normalized.includes('calorie') || normalized.includes('burned'))
        return 'text-orange-600';
    if (normalized.includes('elevation')) return 'text-success';
    if (normalized.includes('step')) return 'text-info';
    if (normalized.includes('facility') || normalized.includes('visit'))
        return 'text-success';

    return 'text-muted-foreground';
};
